import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), {}, {
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M21 12h-1V9h-8v3h-1V8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5V12M20.5 24h-9a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5M12 23h8v-5h-8v5"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23.5 20H22v-1h1v-5H9v5h1v1H8.5a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5M18 21h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1"
      })]
    })
  }));
};
export default SvgComponent;